module.exports = __webpack_public_path__ + "img/graphic-3.b329347a.svg";